module.exports = __webpack_public_path__ + "static/media/eyris-report.0de9c3d4.png";